// main
import { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Jazzicon, { jsNumberForAddress } from 'react-jazzicon';

import WebbDividerMedium from "../webx/webb-divider-md"
import WebbDividerSmall from "../webx/webb-divider-sm";
import WebbSpinner from "../webx/webb-spinner";

import MediaActions from "./media-actions";
import TokenCardMedium from "../webx/token-card-md";
import MediaCreators from "../webx/media-creators";

import { GetUserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";

import { MediaStatus } from "../../services/srvc-media-realm";

import { Row, Col, Image, Form, Input, Typography, Space, Button } from 'antd';
const { Paragraph } = Typography;

const actionslist = require('../../data/data-actions-media.json').data
const contributorlist = require('../../data/data-contributors.json').data
const commentslist = require('../../data/data-comments.json').data
const fallback = "data:image/png;base64,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"

export default function MediaViewModule () {
  
  const usxx = GetUserForm();
  const asset = GetUserForm() === "in" ? GetLocalUser() : GetLocalBusiness();
  
  const {id} = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  
  const [info, setInfo] = useState();
  const [memo, setMemo] = useState();
  const [creators, setCreators] = useState();
  const [actions, setActions] = useState();

  useEffect( async () => {
    if (asset){
      const fetchData = async() => {
        
        setLoading(true);

        const media = await MediaStatus({
          data: {media: id},
          user: asset.usid
        })
        console.log(media)
        setInfo(media.data)

        setMemo(commentslist);

        const creator = [...media.data.media.owner, ...media.data.media.team ]
        setCreators(creator);
        setActions(actionslist);

        setLoading(false);
      }
      fetchData()
    } else {}
  },[]);

  const onFinish = async (values) => {

  }
  
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  if (loading) return <WebbSpinner />

  return (
  <>

    <div 
      className='text-center' 
      style={{height: '420px', width: '100%', backgroundColor:'#121212'}}>
      <Image
        height={'100%'}
        width={'auto'}
        src={info && info.media.link}
        fallback={fallback}
      />
    </div>
    <WebbDividerSmall />
    <div className="">
      <Row justify="space-between" align="top">
        <Col span={21}>
          <Row justify="start" align="middle">
            <Col flex="auto" className="">
              <h3 className="m-0 text-color-main">{info.media.name}</h3>
              <p className="m-0 mb-2">{info.media.memo}</p>
            </Col>
          </Row>
        </Col>

        <Col span={3} className="py-1 text-end" >
          <Space direction="horizontal" 
            style={{width: '100%', justifyContent: 'right'}}>
              <div className="p-1 rounded-wd back-color-next text-color-wite hirich cursor">
                BUY: $M{info.media.rate}
              </div>
          </Space>
        
        </Col>
      </Row>
      <p className="text-color-tone m-0 mb-2">Created: {(new Date(info.media.created)).toLocaleString().substring(0,10)}</p>
      <p className="m-0">IPFS: </p>
      <p className="m-0 mb-2">TokenID: </p>
    </div>

    {/* actions */}
    <WebbDividerSmall />
    <MediaActions data={{item: info.media}}/>
    <WebbDividerSmall />

    {/* creators */}
    <WebbDividerMedium />
    <h4 className="text-color-tone m-0">Creators & Contributors</h4>
    <WebbDividerSmall />
    <MediaCreators data={creators}/>

    <WebbDividerMedium />
    <h4 className="text-color-tone m-0">Comments</h4>
    <WebbDividerSmall />
    <div className="border">
    
        <div 
          className="mb-2" 
          style={{height:'320px', overflowY:'auto'}}>

          {memo && memo.map((item, i) => (

            <div className="p-1" key={i}>
              <Row justify="start" align="top" wrap={false}>
                <Col flex="none" className=""  style={{lineHeight:'0rem'}}>
                  <Jazzicon diameter={33} seed={jsNumberForAddress(item.usid)} />
                </Col>
                
                <Col flex="auto" className="text-start">
                  <div className="">
                    <p className="m-0 ms-1 p-0 text-color-tone text-small">{item.usid}</p>
                    <p className="m-0 ms-1">{item.memo}</p>
                  </div> 
                </Col>

              </Row>
            </div>
          ))}
        </div>

        <div 
          className="border-top" 
          style={{position:'relative', height:'37px'}}>

        <Form
          name="auth"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          className="border-none"
        >
        <Form.Item
          name="memo" 
          
          rules={[{ required: true, message: 'Please enter your message!' }]}
        >
          <Input 
            placeholder="enter message" size="large" 
            className="border-none"
            style={{fontSize:'0.9rem'}}
          />
        </Form.Item>
        </Form>
        </div>

    </div>

  </>
  )
}